import colorMod from 'color';

export default ({ color, fontSize, typography }) => ({
  filterWrapper: {
    display: 'inline-block',
    marginBottom: 7,
  },
  button: {
    margin: '10px 10px',
    borderColor: `${color.primaryButtonBackground} !important`,
    color: `${color.primaryButtonText} !important`,
    fontSize: `${fontSize.buttonText} !important`,
    fontFamily: `${typography.bodyText} !important`,
    height: 40,
  },
  popupBtn: {
    width: 92,
    background: '#fff',
    border: `1px solid ${color.primaryButtonBackground}`,
    color: color.primaryButtonBackground,
    height: 32,
    fontWeight: 'normal',
    padding: 0,
    fontFamily: `${typography.bodyText} !important`,
    borderRadius: 3,
    '& span': {
      textAlign: 'left',
      width: '100%',
    },
    '&:focus': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.primaryButtonBackground}`,
    },
    '&:hover': {
      background: '#F5FAFF',
    },
  },
  addFilterBtn: {
    width: 102,
    background: '#fff',
    border: `1px solid ${color.primaryButtonBackground}`,
    color: color.primaryButtonBackground,
    height: 32,
    fontFamily: typography.bodyText,
    fontWeight: 'normal',
    padding: 0,
    marginRight: 8,
    '& span': {
      textAlign: 'left',
    },
    '&:focus': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.primaryButtonBackground}`,
    },
    '&:hover': {
      background: '#F5FAFF',
    },
  },
  arrowBtn: {
    display: 'inline',
    color: color.primaryButtonBackground,
    fontSize: 11,
    float: 'right',
  },
  addFilterDropdown: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    width: 372,
    color: color.link,
    background: color.uiBackground,
    marginTop: 10,
    alignItems: 'flex-start',
    boxShadow: '0px 4px 8px #00000033',
    zIndex: 10,
  },
  filterTypeBtn: {
    background: 'rgba(0, 0, 0, 0)',
    border: 0,
    fontWeight: 'normal',
    color: color.link,
    fontFamily: typography.bodyText,
    minWidth: 0,
    paddingLeft: 16,
    '& span:last-child': {
      textAlign: 'left',
      width: '100%',
    },
    '&:hover': {
      color: color.linkHover,
    },
    '&:focus': {
      boxShadow: 'none',
    },
  },
  filterTypeBtn__disabled: {
    color: colorMod(color.bodyText).alpha(0.8).string(),
    pointerEvents: 'none',
    borderRadius: 0,
  },
  dropdownOpen: {
    transform: 'rotate(180deg)',
  },
  closeButton: {
    border: `1px solid ${color.primaryButtonBackground}`,
    color: color.primaryButtonBackground,
    height: 32,
    minWidth: 40,
    padding: 0,
    paddingLeft: 8,
    width: 32,
    background: '#fff',
    marginRight: 20,
    '&:focus': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.primaryButtonBackground}`,
    },
  },
  editFilterContainer: {
    display: 'inline-block',
  },
  filterTitle: {
    fontSize: 10,
    color: '#2C485C',
    paddingBottom: 5,
  },
});